$(document).ready(function(){


	/*window handler*/
	$('.xmas .item:not(.locked)').click(function(){
		$('.xmas .window').removeClass('active');
		var day = $(this).data('day');
		$('.window.day-'+day).addClass('active');
	});
	$('.xmas .window .close').click(function(){
		$('.xmas .window').removeClass('active');
	});


	/*submitting*/
	$('form.handlexmas').submit(function(e){

		e.preventDefault();

		/*prepare*/
		const trigger = $(this).find('button.submit');
		trigger.html(trigger.attr('sending'));

		/*create form data*/
		var data = new FormData($(this)[0]);

		/*post*/
		$.ajax({
			type: 'POST',
			url: './files/handler/handle.xmas.php',
			data: data,
			async: true,
			cache: false,
			contentType: false,
			processData: false,
			success: function(reply){

				/*feedback*/
				if(reply == 'ok'){
					trigger.html(trigger.attr('success'));
					trigger.prop('disabled', true);
					trigger.addClass('sent');
				}else{
					trigger.html(trigger.attr('error'));
				}

			}

		});

	});

});


/*arrows*/
$('.arrows .feather-arrow-left').click(function(){
	var left = $('.items').scrollLeft();
	$('.items').animate({scrollLeft: left-500}, 300);
});
$('.arrows .feather-arrow-right').click(function(){
	var left = $('.items').scrollLeft();
	$('.items').animate({scrollLeft: left+500}, 300);
});


